/**
 * Created by Ning Jiang on 11/19/2018.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TombstoneGameConfig} from "../../TombstoneGameConfig";
import {TimelineLite, TweenLite} from "gsap";

export class FreespinRetriggerView extends BaseView {

    private _layer:ScalableLayer;
    private _plus1:PIXI.Sprite;
    private _plus2:PIXI.Sprite;

    constructor() {
        super();
        this._layer = StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
    }

    protected initAnimations():void {
        this._plus1 = this.createText("FS+1");
        this._plus2 = this.createText("FS+2");
    }

    private createText(string:string):PIXI.Sprite {
        const text:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(string)[0]);
        text.anchor.set(0.5);
        text.alpha = 0;
        this._layer.addChild(text);

        return text;
    }

    public getReelRetriggerTimeline(reelId:number, symbolId:number, amount:number):TimelineLite {
        const timeline:TimelineLite = new TimelineLite();
        const position:[number, number] = Helper.getSymbolPositions(reelId, symbolId);
        const text:PIXI.Sprite = <PIXI.Sprite>(<any>this)[`_plus${amount}`];
        text.position.set(position[0], position[1]);
        timeline.add([
            TweenLite.fromTo(text, 0.2, {alpha : 0}, {alpha : 1}),
            TweenLite.to(text, 0.8, {y : position[1] - 50}),
        ]);
        timeline.add(TweenLite.to(text, 0.2, {alpha : 0}), '-=0.2');

        return timeline;
    }
}